import { makeStylesV5 } from '../..';
import CssVariables from '../../../assets/styles/css-variables';
export default makeStylesV5()((theme, { activeMenuColor }) => ({
    coreMenuItemWrapper: {
        position: 'relative',
        '& .menu-item+.new-tab-icon:hover': {
            '& svg': {
                opacity: 1
            }
        },
        '& .menu-item': {
            '&.active': {
                backgroundColor: '#F5F5F5',
                ['&::before']: {
                    content: '""',
                    width: 5,
                    height: '100%',
                    position: 'absolute',
                    left: 0,
                    backgroundColor: activeMenuColor || CssVariables.primaryMain,
                }
            }
        },
        '& .new-tab-icon': {
            cursor: 'pointer',
            position: 'absolute',
            right: 0,
            top: 0,
            margin: '0 !important',
            padding: 10,
            alignItems: 'flex-end',
            pointerEvents: 'auto',
            transition: 'all 0.2s ease',
            color: 'lightgray',
            ['&:hover']: {
                opacity: 0.6,
                background: '#EFEFEF',
                color: 'gray',
            },
            '& svg': {
                fontSize: 16,
                verticalAlign: 'middle',
                opacity: 0
            }
        }
    },
    nested: {
        position: 'relative',
        '& .menu-item': {
            paddingLeft: 25,
            border: 'none !important',
            background: '#f3f3f3',
            ['&::before']: {
                content: '""',
                width: 5,
                height: '100%',
                position: 'absolute',
                left: 0,
                backgroundColor: activeMenuColor || CssVariables.primaryMain,
            },
            '&.active': {
                ['&::after']: {
                    content: '""',
                    position: 'absolute',
                    left: 5,
                    width: 0,
                    height: 0,
                    borderTop: '11px solid transparent',
                    borderBottom: '11px solid transparent',
                    borderLeft: '10px solid',
                    backgroundColor: 'unset',
                    borderLeftColor: activeMenuColor || CssVariables.primaryMain
                }
            },
        },
    }
}));
//# sourceMappingURL=styles.js.map